import { gql } from '@apollo/client';

export const getBusinessPartnerDetailsInfo = gql`
  query getBusinessPartnerDetailsInfo($id: String!) {
    SalesforceManagement {
      entities {
        businessPartner(id: $id) {
          queries {
            salesforceManagement {
              relatedUsers {
                createdBy_firstName
                createdBy_lastName
                modifiedBy_firstName
                modifiedBy_lastName
              }
            }
          }
          views {
            SalesforceManagement_all {
              properties {
                Code
                Status
                Type {
                  Id
                  Title
                }
                TaxAccount
                Account
                RegisterNumber
                IsRegistered
                IsLocal
                IsCompany
                AllowAccessToAllInsured
                createdOn
                createdBy
                modifiedOn
                modifiedBy
                MaxCreditLimitAllowedCurrency {
                  Id
                  Title
                }
                MaxCreditLimitAllowed
                Category {
                  Id
                  Title
                }
                RelatedCompany {
                  Id
                  Title
                }
                PersonID {
                  id
                  views {
                    SalesforceManagement_all {
                      properties {
                        FullName
                        Email
                        PersonCode
                        DateOfBirth
                        PhoneDetails {
                          PhoneType
                          PhoneNumber
                        }
                        IsTaxable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
